<template>
    <div class="modal-overlay" @click.self="$emit('close')">
        <div class="modal-content">
            <div class="modal-header">
                <div class="header-content">
                    <div class="icon-wrapper">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" fill="currentColor"/>
                        </svg>
                    </div>
                    <div>
                        <h2>Add New Room</h2>
                        <p>Create a new room with all necessary details</p>
                    </div>
                </div>
                <button class="close-btn" @click="$emit('close')" aria-label="Close modal">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15 5L5 15M5 5l10 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                </button>
            </div>
            <div class="form-container">
                <form @submit.prevent="submitForm">
                    <!-- =========================================== HOSTEL FORM START =========================================== -->
                    <div v-if="isHostelAdmin" class="form-grid">
                        <div class="input-group">
                            <label for="spaceCategory">Room Type <span class="required">*</span></label>
                            <div class="input-wrapper">
                                <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" fill="currentColor"/>
                                </svg>
                                <select id="spaceCategory" v-model="form.totalNumberOfBed" required :disabled="isSubmitting">
                                    <option value="" disabled>Select Room Type</option>
                                    <option v-for="type in objectData.availableRoomType" :key="type" :value="type">
                                        {{ type.replace('S', ' Sharing') }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <!-- <div class="input-group">
                            <label for="roomUtensils">Room Utensils <span class="required">*</span></label>
                            <div class="tags-input-container">
                                <div class="tags">
                                    <span v-for="(utensil, index) in form.roomUtensils" :key="index" class="tag">
                                        {{ utensil }}
                                        <span class="remove-tag" @click="removeUtensil(index)">×</span>
                                    </span>
                                </div>
                                <input type="text" v-model="utensilInput" @keydown.enter.prevent="addUtensil"
                                    @keydown.backspace="handleBackspace" placeholder="Add utensil and press Enter"
                                    class="tags-input" :disabled="isSubmitting">
                            </div>
                        </div> -->
                        <div class="input-group dynamicinput full-width room-numbers-section">
                            <div class="room-numbers-header">
                                <div class="room-numbers-title-wrap">
                                    <label>Room Numbers <span class="required">*</span></label>
                                    <span class="room-count-badge">{{ form.roomNumbers.length }} added</span>
                                </div>
                                <button type="button" class="room-add-btn" @click="addRoomNumberField" :disabled="isSubmitting">
                                    <span class="plus-icon">+</span>
                                    Add Room Number
                                </button>
                            </div>
                            <div class="room-numbers-grid">
                                <div v-for="(roomNumber, index) in form.roomNumbers" :key="index" class="room-number-input">
                                    <div class="room-number-row">
                                        <div class="input-wrapper">
                                            <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" fill="currentColor"/>
                                            </svg>
                                            <input type="text" :placeholder="`Enter Room Number ${index + 1}`"
                                                v-model="form.roomNumbers[index]" required :disabled="isSubmitting">
                                        </div>
                                        <button type="button" class="room-remove-btn"
                                            @click="removeRoomNumberField(index)"
                                            :disabled="isSubmitting || form.roomNumbers.length === 1">
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- =========================================== HOSTEL FORM END =========================================== -->
                    <!-- =========================================== HOTEL FORM START =========================================== -->
                    <div v-if="isHotelAdmin" class="form-grid">
                        <div class="input-group">
                            <label for="spaceCategory">Room Category <span class="required">*</span></label>
                            <div class="input-wrapper">
                                <svg class="input-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" fill="currentColor"/>
                                </svg>
                                <input type="text" id="spaceCategory" v-model="form.spaceCategory" required
                                    placeholder="Enter Space Category" :disabled="isSubmitting">
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="spaceTotalRoom">Total Number of Rooms <span class="required">*</span></label>
                            <input type="number" id="spaceTotalRoom" v-model.number="form.spaceTotalRoom" required
                                placeholder="Enter Total Rooms">
                        </div>
                        <div class="form-group">
                            <label for="totalNumberOfBed">Total Number of Beds <span class="required">*</span></label>
                            <input type="number" id="totalNumberOfBed" v-model.number="form.totalNumberOfBed" required
                                placeholder="Enter Number of Beds">
                        </div>
                        <div class="form-group">
                            <label for="bedType">Bed Type <span class="required">*</span></label>
                            <input type="text" id="bedType" v-model="form.bedType" required
                                placeholder="Enter Bed Type">
                        </div>
                        <div class="form-group">
                            <label for="spaceTitle">Space Title <span class="required">*</span></label>
                            <input type="text" id="spaceTitle" v-model="form.spaceTitle" required
                                placeholder="Enter Space Title">
                        </div>
                        <div class="form-group">
                            <label for="spaceCapacity">Space Capacity <span class="required">*</span></label>
                            <input type="number" id="spaceCapacity" v-model.number="form.spaceCapacity" required
                                placeholder="Enter Space Capacity">
                        </div>
                        <div class="form-group">
                            <label for="objectBookingAmount">Booking Amount <span class="required">*</span></label>
                            <input type="number" id="objectBookingAmount" v-model.number="form.objectBookingAmount"
                                required placeholder="Enter Booking Amount">
                        </div>
                        <div class="form-group">
                            <label for="totalNumberOfAdults">Total Number of Adults <span
                                    class="required">*</span></label>
                            <input type="number" id="totalNumberOfAdults" v-model.number="form.totalNumberOfAdults"
                                required placeholder="Enter Number of Adults">
                        </div>
                        <div class="form-group">
                            <label for="totalNumberOfKids">Total Number of Kids <span class="required">*</span></label>
                            <input type="number" id="totalNumberOfKids" v-model="form.totalNumberOfKids" required
                                placeholder="Enter Number of Kids">
                        </div>
                        <div class="form-group">
                            <label for="roomUtensils">Room Utensils <span class="required">*</span></label>
                            <div class="tags-input-container">
                                <div class="tags">
                                    <span v-for="(utensil, index) in form.roomUtensils" :key="index" class="tag">
                                        {{ utensil }}
                                        <span class="remove-tag" @click="removeUtensil(index)">×</span>
                                    </span>
                                </div>
                                <input type="text" v-model="utensilInput" @keydown.enter.prevent="addUtensil"
                                    @keydown.backspace="handleBackspace" placeholder="Add utensil and press Enter"
                                    class="tags-input">
                            </div>
                        </div>
                    </div>
                    <!-- =========================================== HOTEL FORM END =========================================== -->
                    <!-- =========================================== HOUSE FORM START =========================================== -->
                    <div v-if="isHouseAdmin" class="form-row">
                        <div class="form-group">
                            <label for="spaceCategory">Room Category <span class="required">*</span></label>
                            <input type="text" id="spaceCategory" v-model="form.spaceCategory" required
                                placeholder="Enter Space Category">
                        </div>
                        <div class="form-group">
                            <label for="spaceTotalRoom">Total Number of Rooms <span class="required">*</span></label>
                            <input type="number" id="spaceTotalRoom" v-model.number="form.spaceTotalRoom" required
                                placeholder="Enter Total Rooms">
                        </div>
                        <div class="form-group">
                            <label for="totalNumberOfBed">Total Number of Beds <span class="required">*</span></label>
                            <input type="number" id="totalNumberOfBed" v-model.number="form.totalNumberOfBed" required
                                placeholder="Enter Number of Beds">
                        </div>
                        <div class="form-group">
                            <label for="bedType">Bed Type <span class="required">*</span></label>
                            <input type="text" id="bedType" v-model="form.bedType" required
                                placeholder="Enter Bed Type">
                        </div>
                        <div class="form-group">
                            <label for="spaceTitle">Space Title <span class="required">*</span></label>
                            <input type="text" id="spaceTitle" v-model="form.spaceTitle" required
                                placeholder="Enter Space Title">
                        </div>
                        <div class="form-group">
                            <label for="spaceCapacity">Space Capacity <span class="required">*</span></label>
                            <input type="number" id="spaceCapacity" v-model.number="form.spaceCapacity" required
                                placeholder="Enter Space Capacity">
                        </div>
                        <div class="form-group">
                            <label for="objectBookingAmount">Booking Amount <span class="required">*</span></label>
                            <input type="number" id="objectBookingAmount" v-model.number="form.objectBookingAmount"
                                required placeholder="Enter Booking Amount">
                        </div>
                        <div class="form-group">
                            <label for="totalNumberOfAdults">Total Number of Adults <span
                                    class="required">*</span></label>
                            <input type="number" id="totalNumberOfAdults" v-model.number="form.totalNumberOfAdults"
                                required placeholder="Enter Number of Adults">
                        </div>
                        <div class="form-group">
                            <label for="totalNumberOfKids">Total Number of Kids <span class="required">*</span></label>
                            <input type="number" id="totalNumberOfKids" v-model="form.totalNumberOfKids" required
                                placeholder="Enter Number of Kids">
                        </div>
                        <div class="form-group">
                            <label for="roomUtensils">Room Utensils <span class="required">*</span></label>
                            <div class="tags-input-container">
                                <div class="tags">
                                    <span v-for="(utensil, index) in form.roomUtensils" :key="index" class="tag">
                                        {{ utensil }}
                                        <span class="remove-tag" @click="removeUtensil(index)">×</span>
                                    </span>
                                </div>
                                <input type="text" v-model="utensilInput" @keydown.enter.prevent="addUtensil"
                                    @keydown.backspace="handleBackspace" placeholder="Add utensil and press Enter"
                                    class="tags-input">
                            </div>
                        </div>
                    </div>
                    <!-- =========================================== HOUSE FORM END =========================================== -->
                    <!-- =========================================== PROPERTY FORM START =========================================== -->
                    <div v-if="isPropertyAdmin" class="form-row">
                        <div class="form-group">
                            <label for="spaceCategory">Room Category <span class="required">*</span></label>
                            <input type="text" id="spaceCategory" v-model="form.spaceCategory" required
                                placeholder="Enter Space Category">
                        </div>
                        <div class="form-group">
                            <label for="spaceTotalRoom">Total Number of Rooms <span class="required">*</span></label>
                            <input type="number" id="spaceTotalRoom" v-model.number="form.spaceTotalRoom" required
                                placeholder="Enter Total Rooms">
                        </div>
                        <div class="form-group">
                            <label for="totalNumberOfBed">Total Number of Beds <span class="required">*</span></label>
                            <input type="number" id="totalNumberOfBed" v-model.number="form.totalNumberOfBed" required
                                placeholder="Enter Number of Beds">
                        </div>
                        <div class="form-group">
                            <label for="bedType">Bed Type <span class="required">*</span></label>
                            <input type="text" id="bedType" v-model="form.bedType" required
                                placeholder="Enter Bed Type">
                        </div>
                        <div class="form-group">
                            <label for="spaceTitle">Space Title <span class="required">*</span></label>
                            <input type="text" id="spaceTitle" v-model="form.spaceTitle" required
                                placeholder="Enter Space Title">
                        </div>
                        <div class="form-group">
                            <label for="spaceCapacity">Space Capacity <span class="required">*</span></label>
                            <input type="number" id="spaceCapacity" v-model.number="form.spaceCapacity" required
                                placeholder="Enter Space Capacity">
                        </div>
                        <div class="form-group">
                            <label for="objectBookingAmount">Booking Amount <span class="required">*</span></label>
                            <input type="number" id="objectBookingAmount" v-model.number="form.objectBookingAmount"
                                required placeholder="Enter Booking Amount">
                        </div>
                        <div class="form-group">
                            <label for="totalNumberOfAdults">Total Number of Adults <span
                                    class="required">*</span></label>
                            <input type="number" id="totalNumberOfAdults" v-model.number="form.totalNumberOfAdults"
                                required placeholder="Enter Number of Adults">
                        </div>
                        <div class="form-group">
                            <label for="totalNumberOfKids">Total Number of Kids <span class="required">*</span></label>
                            <input type="number" id="totalNumberOfKids" v-model="form.totalNumberOfKids" required
                                placeholder="Enter Number of Kids">
                        </div>
                        <div class="form-group">
                            <label for="roomUtensils">Room Utensils <span class="required">*</span></label>
                            <div class="tags-input-container">
                                <div class="tags">
                                    <span v-for="(utensil, index) in form.roomUtensils" :key="index" class="tag">
                                        {{ utensil }}
                                        <span class="remove-tag" @click="removeUtensil(index)">×</span>
                                    </span>
                                </div>
                                <input type="text" v-model="utensilInput" @keydown.enter.prevent="addUtensil"
                                    @keydown.backspace="handleBackspace" placeholder="Add utensil and press Enter"
                                    class="tags-input">
                            </div>
                        </div>
                    </div>
                    <!-- =========================================== PROPERTY FORM END =========================================== -->
                    <div v-if="!isHostelAdmin" class="form-row">
                        <div class="form-group">
                            <label for="featuredImage">Featured Image <span class="required">*</span></label>
                            <input type="file" id="featuredImage" @change="handleFeaturedImageUpload" accept="image/*" :disabled="isUploadingFeatured">
                            <div v-if="featuredImagePreview" class="image-preview-container" :class="{ 'uploading': isUploadingFeatured }">
                                <img :src="featuredImagePreview" class="image-preview">
                                <div v-if="isUploadingFeatured" class="upload-loading-overlay">
                                    <div class="spinner-container">
                                        <div class="modern-spinner">
                                            <div class="spinner-ring"></div>
                                            <div class="spinner-ring"></div>
                                            <div class="spinner-ring"></div>
                                        </div>
                                        <p class="uploading-text">Uploading...</p>
                                    </div>
                                </div>
                                <span v-if="!isUploadingFeatured" class="remove-image" @click="removeFeaturedImage">×</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="spaceImage">Space Images <span class="required">*</span></label>
                            <input type="file" id="spaceImage" multiple @change="handleSpaceImagesUpload"
                                accept="image/*">
                            <div class="image-previews">
                                <div v-for="(preview, index) in spaceImagePreviews" :key="index"
                                    class="image-preview-container"
                                    :class="{ 'uploading': uploadingSpaceImages[index] }">
                                    <img :src="preview" class="image-preview">
                                    <div v-if="uploadingSpaceImages[index]" class="upload-loading-overlay">
                                        <div class="spinner-container">
                                            <div class="modern-spinner">
                                                <div class="spinner-ring"></div>
                                                <div class="spinner-ring"></div>
                                                <div class="spinner-ring"></div>
                                            </div>
                                            <p class="uploading-text">Uploading...</p>
                                        </div>
                                    </div>
                                    <span v-if="!uploadingSpaceImages[index]" class="remove-image" @click="removeSpaceImage(index)">×</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-actions">
                        <button type="button" class="btn-secondary" @click="$emit('close')" :disabled="isSubmitting">
                            Cancel
                        </button>
                        <button type="submit" class="btn-primary" :disabled="isSubmitting">
                            <span v-if="!isSubmitting">Add Room</span>
                            <span v-else class="loading-content">
                                <svg class="spinner" width="16" height="16" viewBox="0 0 24 24">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none" opacity="0.25"/>
                                    <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" fill="currentColor"/>
                                </svg>
                                Adding...
                            </span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <!-- Toast Notifications -->
    <div class="toast-container">
        <transition-group name="toast" tag="div">
            <div 
                v-for="toast in toasts" 
                :key="toast.id" 
                class="toast"
                :class="[`toast-${toast.type}`]"
            >
                <div class="toast-icon">
                    <svg v-if="toast.type === 'error'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"/>
                        <line x1="15" y1="9" x2="9" y2="15"/>
                        <line x1="9" y1="9" x2="15" y2="15"/>
                    </svg>
                    <svg v-else-if="toast.type === 'success'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                        <polyline points="22,4 12,14.01 9,11.01"/>
                    </svg>
                    <svg v-else-if="toast.type === 'info'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <circle cx="12" cy="12" r="10"/>
                        <line x1="12" y1="16" x2="12" y2="12"/>
                        <line x1="12" y1="8" x2="12.01" y2="8"/>
                    </svg>
                    <svg v-else-if="toast.type === 'warning'" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
                        <line x1="12" y1="9" x2="12" y2="13"/>
                        <line x1="12" y1="17" x2="12.01" y2="17"/>
                    </svg>
                </div>
                <div class="toast-content">
                    <p class="toast-message">{{ toast.message }}</p>
                </div>
                <button class="toast-close" @click="removeToast(toast.id)">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            </div>
        </transition-group>
    </div>
</template>

<script>
import apiService from '@/services/api';
import { isNoDataError, isHmsSubscriptionInactiveError } from '@/utilities/errorHelper';

export default {
    name: 'AddRoomForm',
    props: {
        objectSpaces: {
            type: Array,
            required: true,
        },
        objectData: {
            type: Object,
            required: true,
        },
        isLoading: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            isSubmitting: false,
            isHostelAdmin: false,
            isHotelAdmin: false,
            isHouseAdmin: false,
            isPropertyAdmin: false,
            objectSpaceProps: {},
            adminProfileData: {},
            form: {
                objectId: this.$route.params.id,
                spaceCategory: '',
                spaceTotalRoom: '',
                totalNumberOfBed: '',
                bedType: '',
                spaceTitle: '',
                featuredImage: null,
                spaceImage: [],
                roomUtensils: [],
                spaceCapacity: '',
                objectBookingAmount: '',
                totalNumberOfKids: '',
                totalNumberOfAdults: '',
                roomNumbers: [],
            },
            utensilInput: '',
            featuredImagePreview: null,
            spaceImagePreviews: [],
            featuredImageUrl: null,
            spaceImageUrls: [],
            maxImages: 10,
            maxFileSize: 5 * 1024 * 1024,
            allowedTypes: ['image/jpeg', 'image/png', 'image/gif'],
            toasts: [],
            isUploadingFeatured: false,
            uploadingSpaceImages: []
        };
    },
    mounted() {
        // Check adminType from localStorage
        let adminProfile = localStorage.getItem('ADMIN_PROFILE_DATA');
        this.adminProfileData = localStorage.getItem('ADMIN_PROFILE_DATA');
        this.adminProfileData = JSON.parse(this.adminProfileData);
        if (this.objectSpaces && this.objectSpaces.length > 0) {
            this.objectSpaceProps = this.objectSpaces[0];
        }
        if (adminProfile) {
            try {
                adminProfile = JSON.parse(adminProfile);
                if (adminProfile.adminType === 'HOSTEL') {
                    this.isHostelAdmin = true;
                    if (!this.form.roomNumbers.length) {
                        this.form.roomNumbers = [''];
                        this.form.spaceTotalRoom = 1;
                    }
                } else if (adminProfile.adminType === 'HOTEL') {
                    this.isHotelAdmin = true;
                } else if (adminProfile.adminType === 'HOUSE') {
                    this.isHouseAdmin = true;
                } else if (adminProfile.adminType === 'PROPERTY') {
                    this.isPropertyAdmin = true;
                }
            } catch (e) {
                // handle error if needed
                console.error('Error parsing admin profile data:', e);
            }
        }
    },
    methods: {
        // Toast notification methods
        showToast(message, type = 'error', duration = 5000) {
            const id = Date.now() + Math.random();
            this.toasts.push({ id, message, type });
            
            if (duration > 0) {
                setTimeout(() => {
                    this.removeToast(id);
                }, duration);
            }
        },
        removeToast(id) {
            this.toasts = this.toasts.filter(toast => toast.id !== id);
        },
        addRoomNumberField() {
            this.form.roomNumbers.push('');
            this.form.spaceTotalRoom = this.form.roomNumbers.length;
        },
        removeRoomNumberField(index) {
            if (this.form.roomNumbers.length <= 1) return;
            this.form.roomNumbers.splice(index, 1);
            this.form.spaceTotalRoom = this.form.roomNumbers.length;
        },
        handleRoomLimit() {
            if (this.form.spaceTotalRoom > 50) {
                this.form.spaceTotalRoom = 50;
            }
            if (this.form.spaceTotalRoom !== '' && this.form.spaceTotalRoom < 1) {
                this.form.spaceTotalRoom = 1;
            }
        },
        validateFile(file) {
            return this.allowedTypes.includes(file.type) && file.size <= this.maxFileSize;
        },
        async handleFeaturedImageUpload(event) {
            const file = event.target.files[0];
            if (!file) return;
            
            // Check file size (5MB limit)
            if (file.size > this.maxFileSize) {
                this.showToast('Image size exceeds 5MB limit. Please select a smaller image.', 'error');
                event.target.value = '';
                return;
            }
            
            if (this.validateFile(file)) {
                // Create preview immediately
                const reader = new FileReader();
                reader.onload = e => {
                    this.featuredImagePreview = e.target.result;
                };
                reader.readAsDataURL(file);
                
                // Upload image immediately
                this.isUploadingFeatured = true;
                await this.uploadSingleImage(file, 'featured');
                this.isUploadingFeatured = false;
            } else {
                this.showToast('Invalid file type. Please upload a valid image file (JPEG, PNG, or GIF) under 5MB.', 'error');
                event.target.value = '';
            }
        },
        async handleSpaceImagesUpload(event) {
            const files = Array.from(event.target.files);
            for (let file of files) {
                // Check file size (5MB limit)
                if (file.size > this.maxFileSize) {
                    this.showToast('One or more images exceed 5MB limit. Please select smaller images.', 'error');
                    continue;
                }
                
                if (this.validateFile(file)) {
                    if (this.spaceImageUrls.length < this.maxImages) {
                        // Create preview immediately
                        const reader = new FileReader();
                        const currentIndex = this.spaceImagePreviews.length;
                        reader.onload = e => {
                            this.spaceImagePreviews.push(e.target.result);
                            // Initialize loading state for this image
                            this.$set(this.uploadingSpaceImages, currentIndex, true);
                        };
                        reader.readAsDataURL(file);
                        
                        // Upload image immediately
                        await this.uploadSingleImage(file, 'space', currentIndex);
                        this.$set(this.uploadingSpaceImages, currentIndex, false);
                    } else {
                        this.showToast(`Maximum ${this.maxImages} images allowed.`, 'warning');
                        break;
                    }
                } else {
                    this.showToast('One or more files are invalid. Please upload valid image files (JPEG, PNG, or GIF) under 5MB.', 'error');
                }
            }
            event.target.value = '';
        },
        removeFeaturedImage() {
            this.featuredImageUrl = null;
            this.featuredImagePreview = null;
            this.isUploadingFeatured = false;
        },
        removeSpaceImage(index) {
            this.spaceImageUrls.splice(index, 1);
            this.spaceImagePreviews.splice(index, 1);
            this.uploadingSpaceImages.splice(index, 1);
        },
        async uploadSingleImage(file, type, index = null) {
            try {
                const formData = new FormData();
                formData.append('files', file);

                const uploadResponse = await apiService.uploadImage(formData);

                const uploadedFilenames = uploadResponse.data || [];
                if (uploadedFilenames.length > 0) {
                    // Store just the filename
                    const imageFilename = uploadedFilenames[0];
                    
                    if (type === 'featured') {
                        this.featuredImageUrl = imageFilename;
                    } else if (type === 'space') {
                        this.spaceImageUrls.push(imageFilename);
                    }
                    
                    this.showToast('Image uploaded successfully!', 'success', 3000);
                } else {
                    throw new Error('No image URL received from server');
                }
            } catch (error) {
                console.error('Image upload failed:', error);
                // Skip error handling for "no data" cases (status 400 with errorcode 2003)
                if (isNoDataError(error) || isHmsSubscriptionInactiveError(error)) {
                    return;
                }
                
                let message = null;
                if (error?.response?.data) {
                    const errorData = error.response.data;
                    const status = error.response.status;
                    
                    // For HTTP 400 errors, always use the reason field from API response
                    if (status === 400) {
                        if (errorData.reason) {
                            message = errorData.reason;
                        }
                        // If no reason provided for 400 error, don't show toast (no generic messages)
                    } else {
                        // For other status codes, prioritize reason field
                        if (errorData.reason) {
                            message = errorData.reason;
                        } else if (errorData.message) {
                            message = errorData.message;
                        }
                    }
                }
                
                // Only show toast if we have a message (genuine errors only)
                if (message) {
                    this.showToast(message, 'error');
                }
                
                // Remove preview if upload failed
                if (type === 'featured') {
                    this.featuredImagePreview = null;
                    this.isUploadingFeatured = false;
                } else if (type === 'space') {
                    if (index !== null) {
                        this.spaceImagePreviews.splice(index, 1);
                        this.uploadingSpaceImages.splice(index, 1);
                    } else {
                        this.spaceImagePreviews.pop();
                        this.uploadingSpaceImages.pop();
                    }
                }
            }
        },
        addUtensil() {
            const input = this.utensilInput.trim();
            if (input && !this.form.roomUtensils.includes(input)) {
                this.form.roomUtensils.push(input);
                this.utensilInput = '';
            }
        },
        removeUtensil(index) {
            this.form.roomUtensils.splice(index, 1);
        },
        handleBackspace() {
            if (!this.utensilInput && this.form.roomUtensils.length) {
                this.form.roomUtensils.pop();
            }
        },
        async uploadImagesAndSubmit() {
            this.isSubmitting = true;
            try {
                // Use already uploaded image URLs
                let featuredImageUrl = this.featuredImageUrl || '';
                let spaceImageUrls = [...this.spaceImageUrls];

                let payload = {}
                if (this.adminProfileData.adminType === 'HOTEL') {
                    payload = {
                        objectId: this.form.objectId,
                        spaceCategory: this.form.spaceCategory,
                        spaceTotalRoom: String(this.form.spaceTotalRoom || ''),
                        totalNumberOfBed: this.form.totalNumberOfBed.replace(/\D/g, '') || '',
                        bedType: this.form.bedType,
                        spaceTitle: this.form.spaceTitle,
                        featuredImage: featuredImageUrl,
                        spaceImage: spaceImageUrls,
                        roomUtensils: this.form.roomUtensils,
                        spaceCapacity: String(this.form.spaceCapacity || ''),
                        objectBookingAmount: String(this.form.objectBookingAmount || ''),
                        totalNumberOfKids: this.form.totalNumberOfKids !== null && this.form.totalNumberOfKids !== undefined ? String(this.form.totalNumberOfKids) : '0',
                        totalNumberOfAdults: String(this.form.totalNumberOfAdults || ''),
                    };
                }

                if (this.adminProfileData.adminType === 'HOSTEL') {
                    const uniqueRoomNumbers = Array.from(
                        new Set(
                            this.form.roomNumbers
                                .map(room => String(room || '').trim())
                                .filter(Boolean)
                        )
                    );
                    this.form.spaceTotalRoom = uniqueRoomNumbers.length;
                    payload = {
                        objectId: this.form.objectId,
                        spaceCategory: 'ROOM',
                        spaceTotalRoom: String(this.form.spaceTotalRoom || ''),
                        totalNumberOfBed: this.form.totalNumberOfBed.replace(/\D/g, '') || '',
                        roomNumbers: uniqueRoomNumbers
                    };
                }


                const objectspaceResponse = await apiService.createObjectSpace(payload);

                console.log("objectspaceResponse:Data", objectspaceResponse)

                this.showToast('Room added successfully!', 'success', 3000);
                setTimeout(() => {
                    this.$emit('close');
                    window.location.reload();
                }, 1500);
            } catch (error) {
                this.isSubmitting = false;
                console.log('Error uploading or submitting:', error);
                // Skip error handling for "no data" cases (status 400 with errorcode 2003)
                if (isNoDataError(error) || isHmsSubscriptionInactiveError(error)) {
                    return;
                }
                
                let message = null;
                if (error?.response?.data) {
                    const errorData = error.response.data;
                    const status = error.response.status;
                    
                    // For HTTP 400 errors, always use the reason field from API response
                    if (status === 400) {
                        if (errorData.reason) {
                            message = errorData.reason;
                        }
                        // If no reason provided for 400 error, don't show toast (no generic messages)
                    } else {
                        // For other status codes, prioritize reason field
                        if (errorData.reason) {
                            message = errorData.reason;
                        } else if (errorData.message) {
                            message = errorData.message;
                        } else {
                            message = 'Something went wrong while uploading images or saving the data.';
                        }
                    }
                } else {
                    message = 'Something went wrong while uploading images or saving the data.';
                }
                
                // Only show toast if we have a message (genuine errors only)
                if (message) {
                    this.showToast(message, 'error');
                }
            }
        },
        submitForm() {
            this.uploadImagesAndSubmit();
        },
    },
};
</script>


<style scoped>
/* Modal Overlay */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

/* Modal Content */
.modal-content {
    background: #ffffff;
    border-radius: 16px;
    width: 90%;
    max-width: 1000px;
    max-height: 90vh;
    overflow: hidden;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    animation: slideUp 0.3s ease-out;
    position: relative;
    display: grid;
    grid-template-rows: auto 1fr;
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px) scale(0.95);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* Modal Header */
.modal-header {
    background: linear-gradient(135deg, #5b2e8e 0%, #7c3aed 100%);
    color: white;
    padding: 20px 24px;
    position: relative;
    overflow: hidden;
}

.modal-header::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="75" cy="75" r="1" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
    opacity: 0.3;
    pointer-events: none;
}

.header-content {
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
    z-index: 1;
}

.header-content > div {
    text-align: left;
}

.icon-wrapper {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.modal-header h2 {
    margin: 0 0 2px 0;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.3;
    text-align: left;
}

.modal-header p {
    margin: 0;
    font-size: 14px;
    opacity: 0.9;
    font-weight: 400;
    text-align: left;
    line-height: 1.4;
}

.close-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    background: rgba(255, 255, 255, 0.2);
    border: none;
    border-radius: 8px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    color: white;
    z-index: 2;
}

.close-btn:hover {
    background: rgba(255, 255, 255, 0.3);
    transform: scale(1.05);
}

/* Form Container */
.form-container {
    padding: 24px;
    overflow-y: auto;
    max-height: calc(90vh - 100px);
}

/* Form Grid */
.form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-bottom: 24px;
}

.input-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.full-width {
    grid-column: span 3;
}

/* Labels */
label {
    font-weight: 600;
    font-size: 14px;
    color: #374151;
    line-height: 1.4;
    text-align: left;
    display: block;
    margin: 0;
}

.required {
    color: #ef4444;
    font-size: 12px;
    margin-left: 2px;
}

/* Input Wrapper */
.input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.input-icon {
    position: absolute;
    left: 12px;
    color: #6b7280;
    z-index: 1;
    pointer-events: none;
}

/* Input Styles */
input,
textarea {
    width: 100%;
    padding: 12px 14px 12px 44px;
    border: 2px solid #e5e7eb;
    border-radius: 10px;
    font-size: 14px;
    background: #ffffff;
    transition: all 0.2s ease;
    box-sizing: border-box;
}

input:focus,
textarea:focus {
    outline: none;
    border-color: #5b2e8e;
    box-shadow: 0 0 0 3px rgba(91, 46, 142, 0.1);
}

input:disabled,
textarea:disabled {
    background: #f9fafb;
    color: #6b7280;
    cursor: not-allowed;
}

input::placeholder,
textarea::placeholder {
    color: #9ca3af;
    font-size: 14px;
}

/* Select Styles */
select {
    width: 100%;
    padding: 12px 14px 12px 44px;
    border: 2px solid #e5e7eb;
    border-radius: 10px;
    font-size: 14px;
    background: #ffffff;
    color: #374151;
    transition: all 0.2s ease;
    appearance: none;
    outline: none;
    cursor: pointer;
}

select:focus {
    border-color: #5b2e8e;
    box-shadow: 0 0 0 3px rgba(91, 46, 142, 0.1);
}

select:disabled {
    background: #f9fafb;
    color: #6b7280;
    cursor: not-allowed;
}

/* Tags Input Container */
.tags-input-container {
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    padding: 8px;
    min-height: 48px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    background: #ffffff;
    transition: all 0.2s ease;
}

.tags-input-container:focus-within {
    border-color: #5b2e8e;
    box-shadow: 0 0 0 3px rgba(91, 46, 142, 0.1);
}

.tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.tag {
    background: linear-gradient(135deg, #f2e9ff 0%, #e9d5ff 100%);
    color: #5b2e8e;
    padding: 6px 12px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    border: 1px solid rgba(91, 46, 142, 0.2);
}

.remove-tag {
    margin-left: 8px;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
    color: #7c3aed;
    transition: color 0.2s ease;
}

.remove-tag:hover {
    color: #5b2e8e;
}

.tags-input {
    border: none;
    outline: none;
    flex-grow: 1;
    min-width: 150px;
    padding: 8px;
    font-size: 16px;
    background: transparent;
}

/* Room Numbers Grid */
.room-numbers-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 14px;
    margin-top: 6px;
}

.room-number-input {
    width: 100%;
}

.room-numbers-section {
    background: #faf7ff;
    border: 1px solid #e9ddff;
    border-radius: 14px;
    padding: 14px;
}

.room-numbers-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
}

.room-numbers-title-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
}

.room-count-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 24px;
    padding: 2px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 600;
    color: #5b2e8e;
    background: #efe6ff;
    border: 1px solid #dec9ff;
}

.room-number-row {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 8px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.room-number-row:focus-within {
    border-color: #7c3aed;
    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.12);
}

.room-number-row .input-wrapper {
    flex: 1;
}

.room-number-row .input-wrapper input {
    border: 1px solid transparent;
    box-shadow: none;
}

.room-number-row .input-wrapper input:focus {
    border-color: transparent;
    box-shadow: none;
}

.room-add-btn {
    border: 1px solid #7c3aed;
    background: #7c3aed;
    color: #ffffff;
    border-radius: 10px;
    padding: 8px 12px;
    font-size: 13px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.room-add-btn:hover:not(:disabled) {
    background: #6d28d9;
    border-color: #6d28d9;
    transform: translateY(-1px);
}

.room-add-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.plus-icon {
    font-size: 16px;
    line-height: 1;
    font-weight: 700;
}

.room-remove-btn {
    border: 1px solid #fecaca;
    background: #fff1f2;
    color: #b91c1c;
    border-radius: 10px;
    min-height: 38px;
    padding: 0 12px;
    font-size: 13px;
    font-weight: 600;
    flex-shrink: 0;
    cursor: pointer;
    transition: all 0.2s ease;
}

.room-remove-btn:hover:not(:disabled) {
    background: #ffe4e6;
    border-color: #fda4af;
}

.room-remove-btn:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

/* Image Upload Styles */
.image-preview-container {
    position: relative;
    display: inline-block;
    margin: 12px 12px 0 0;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    transition: transform 0.2s ease;
}

.image-preview-container:hover {
    transform: scale(1.02);
}

.image-preview {
    width: 120px;
    height: 120px;
    object-fit: cover;
    border-radius: 12px;
    border: 2px solid #e5e7eb;
}

.image-preview-container.uploading {
    pointer-events: none;
}

.image-preview-container.uploading .image-preview {
    opacity: 0.6;
    filter: blur(2px);
    transition: opacity 0.3s ease, filter 0.3s ease;
}

.upload-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.85);
    backdrop-filter: blur(8px);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 12px;
    z-index: 10;
    animation: fadeInOverlay 0.3s ease-out;
}

@keyframes fadeInOverlay {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.spinner-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
}

/* Modern Professional Spinner */
.modern-spinner {
    position: relative;
    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.spinner-ring {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 3px solid transparent;
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: spin-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.spinner-ring:nth-child(1) {
    width: 56px;
    height: 56px;
    border-top-color: #ffffff;
    border-right-color: rgba(255, 255, 255, 0.3);
    animation-duration: 1.2s;
    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
}

.spinner-ring:nth-child(2) {
    width: 44px;
    height: 44px;
    border-top-color: #a78bfa;
    border-right-color: rgba(167, 139, 250, 0.3);
    animation-duration: 1s;
    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
    animation-direction: reverse;
    top: 6px;
    left: 6px;
}

.spinner-ring:nth-child(3) {
    width: 32px;
    height: 32px;
    border-top-color: #7c3aed;
    border-right-color: rgba(124, 58, 237, 0.3);
    animation-duration: 0.8s;
    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 1);
    top: 12px;
    left: 12px;
}

@keyframes spin-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.uploading-text {
    color: #ffffff;
    font-size: 12px;
    font-weight: 600;
    margin: 0;
    letter-spacing: 0.5px;
    text-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    animation: pulse-text 2s ease-in-out infinite;
}

@keyframes pulse-text {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.7;
    }
}

.image-previews {
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.remove-image {
    position: absolute;
    top: -8px;
    right: -8px;
    background: rgba(239, 68, 68, 0.9);
    color: white;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 14px;
    line-height: 1;
    text-align: center;
    transition: all 0.2s ease;
    border: 2px solid white;
}

.remove-image:hover {
    background: rgba(239, 68, 68, 1);
    transform: scale(1.1);
}

/* Button Styles */
.btn-primary {
    background: linear-gradient(135deg, #5b2e8e 0%, #7c3aed 100%);
    color: white;
    border: none;
    border-radius: 8px;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 36px;
    white-space: nowrap;
}

.btn-primary:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 10px 25px -5px rgba(91, 46, 142, 0.4);
}

.btn-primary:active:not(:disabled) {
    transform: translateY(0);
}

.btn-primary:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.btn-secondary {
    background: #ffffff;
    color: #6b7280;
    border: 2px solid #e5e7eb;
    border-radius: 8px;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 36px;
    white-space: nowrap;
}

.btn-secondary:hover:not(:disabled) {
    background: #f9fafb;
    border-color: #d1d5db;
    transform: translateY(-1px);
}

.btn-secondary:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
}

/* Form Actions */
.form-actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: 24px;
}

/* Loading Animation */
.loading-content {
    display: flex;
    align-items: center;
    gap: 8px;
}

.spinner {
    animation: spin 1s linear infinite;
}

@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

/* Responsive Design */
@media (max-width: 1200px) {
    .modal-content {
        width: 95%;
        max-width: 900px;
    }

    .form-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .full-width {
        grid-column: span 2;
    }
}

@media (max-width: 768px) {
    .modal-content {
        margin: 16px;
        width: calc(100% - 32px);
        max-height: calc(100vh - 32px);
    }

    .modal-header {
        padding: 20px 24px;
    }

    .form-container {
        padding: 24px;
    }

    .header-content {
        gap: 12px;
    }

    .modal-header h2 {
        font-size: 20px;
    }

    .form-grid {
        grid-template-columns: 1fr;
    }

    .full-width {
        grid-column: span 1;
    }

    .form-actions {
        flex-direction: column;
    }

    .btn-primary,
    .btn-secondary {
        width: 100%;
    }

    .room-numbers-grid {
        grid-template-columns: 1fr;
    }

    .room-numbers-header {
        flex-direction: column;
        align-items: flex-start;
    }

    .room-add-btn {
        width: 100%;
        justify-content: center;
    }

    .room-number-row {
        flex-direction: column;
        align-items: stretch;
    }

    .room-remove-btn {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .modal-header {
        padding: 16px 20px;
    }

    .form-container {
        padding: 20px;
    }

    .image-preview {
        width: 100px;
        height: 100px;
    }
}

/* Toast Notification Styles */
.toast-container {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 400px;
    pointer-events: none;
}

.toast {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 20px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
    border-left: 4px solid transparent;
    min-width: 320px;
    pointer-events: auto;
    font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.toast-error {
    border-left-color: #ef4444;
    background: linear-gradient(135deg, #fef2f2, #ffffff);
}

.toast-success {
    border-left-color: #10b981;
    background: linear-gradient(135deg, #f0fdf4, #ffffff);
}

.toast-info {
    border-left-color: #3b82f6;
    background: linear-gradient(135deg, #eff6ff, #ffffff);
}

.toast-warning {
    border-left-color: #f59e0b;
    background: linear-gradient(135deg, #fffbeb, #ffffff);
}

.toast-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
}

.toast-error .toast-icon {
    color: #ef4444;
}

.toast-success .toast-icon {
    color: #10b981;
}

.toast-info .toast-icon {
    color: #3b82f6;
}

.toast-warning .toast-icon {
    color: #f59e0b;
}

.toast-content {
    flex: 1;
    min-width: 0;
}

.toast-message {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    color: #374151;
    line-height: 1.4;
    word-wrap: break-word;
}

.toast-close {
    background: none;
    border: none;
    color: #9ca3af;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.toast-close:hover {
    color: #6b7280;
    background: rgba(0, 0, 0, 0.05);
    transform: scale(1.1);
}

/* Toast Animations */
.toast-enter-active {
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.toast-leave-active {
    transition: all 0.3s cubic-bezier(0.4, 0, 1, 1);
}

.toast-enter-from {
    opacity: 0;
    transform: translateX(100%) scale(0.95);
}

.toast-leave-to {
    opacity: 0;
    transform: translateX(100%) scale(0.95);
}

.toast-move {
    transition: transform 0.3s ease;
}

/* Responsive Toast Styles */
@media (max-width: 768px) {
    .toast-container {
        top: 16px;
        right: 16px;
        left: 16px;
        max-width: none;
    }

    .toast {
        min-width: auto;
        width: 100%;
        padding: 14px 16px;
    }

    .toast-message {
        font-size: 14px;
    }
}

/* Focus and accessibility improvements */
.btn-primary:focus,
.btn-secondary:focus,
.close-btn:focus {
    outline: 2px solid #5b2e8e;
    outline-offset: 2px;
}

/* Smooth transitions for better UX */
* {
    box-sizing: border-box;
}

input,
button,
select,
textarea {
    font-family: inherit;
}
</style>